import { Tab } from '../types';

export const routeTabs = (unroutedTabs: Tab[], url: string): Tab[] => {
  const routedTabs: Tab[] = [];

  unroutedTabs.forEach((tab: any) => {
    if (tab.items) {
      routedTabs.push({
        ...tab,
        items: routeTabs(tab.items, url)
      });
    } else {
      routedTabs.push({
        ...tab,
        route: `${url}${tab.route}`.replace('//', '/'),
      });
    }
  });

  return routedTabs;
};

export const flattenTabs = (tabs: Tab[]): Tab[] => {
  let flatTabs: Tab[] = [];

  tabs.forEach(({ items, ...tab }) => {
    if (items) {
      flatTabs = [...flatTabs, tab, ...flattenTabs(items)];
    } else {
      flatTabs.push(tab);
    }
  });

  return flatTabs;
};
